<template>
  <div
    :class="{
      'right-20': locale !== 'ar',
      'left-20': locale === 'ar',
    }"
    class="z-1 absolute overflow-auto top-14 -mt-2 p-4 bg-white shadow-lg border-2 rounded-lg h-auto w-[70%] lg:w-[50%] xl:w-[35%]"
  >
    <div class="flex flex-row items-center justify-between pb-2">
      <p class="text-subDarkBlue text-lg font-bold">
        {{ $t("notifications") }}
      </p>
      <button @click="closeNotificationTab" class="p-4">
        <svg
          clip-rule="evenodd"
          fill-rule="evenodd"
          width="40"
          height="40"
          viewBox="0 0 24 24"
          class="h-6 fill-slate-500"
        >
          <path
            d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z"
          />
        </svg>
      </button>
    </div>
    <li
      v-if="notificationList.length > 0"
      v-for="notification in notificationList"
      :key="notification.id"
      class="flex w-full py-3 items-center pt-2"
    >
      <div
        @click="handleClickEvent(notification)"
        :class="{
          'bg-slate-200': !notification.seen,
          'bg-slate-50': notification.seen,
          'opacity-60 cursor-not-allowed pointer-events-none': notification.type === 'ONETIME_AUDIO_UPLOAD' && (notification.consumed || notification.uploadAlreadyUsed),
        }"
        class="container flex flex-row items-center p-2 rounded-md cursor-pointer relative"
      >
        <div
          :class="{
            'bg-amber-100': isOneTimeNotification(notification) && notification.type !== 'ONETIME_YOUTUBE_RESULT' && notification.type !== 'ONETIME_AUDIO_UPLOAD' && notification.type !== 'ONETIME_VIDEO_RESULT' && notification.type !== 'ONETIME_AUDIO_RESULT',
            'bg-green-100':
              notification.type == 'VIDEO' || notification.type == 'EXTVIDEO' || notification.type == 'ONETIME_VIDEO_RESULT',
            'bg-red-100': notification.type == 'YOUTUBE' || notification.type == 'ONETIME_YOUTUBE_RESULT',
            'bg-blue-100':
              notification.type == 'AUDIO' ||
              notification.type == 'EXTAUDIO' ||
              notification.type == 'ONETIME_AUDIO_UPLOAD' ||
              notification.type == 'ONETIME_AUDIO_RESULT',
          }"
          class="flex items-center justify-center h-auto w-14 rounded-lg"
        >
          <svg
            v-if="
              notification.type == 'AUDIO' || notification.type == 'EXTAUDIO' || notification.type == 'ONETIME_AUDIO_RESULT'
            "
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            class="fill-[#6193F6] h-10"
          >
            <path
              d="M1 13h-1v-1h1v1zm22-1h-1v1h1v-1zm-20-1h-1v3h1v-3zm18 0h-1v3h1v-3zm-14 0h-1v3h1v-3zm10-1h-1v5h1v-5zm-12 0h-1v5h1v-5zm14-1h-1v7h1v-7zm-10 0h-1v7h1v-7zm2-2h-1v10h1v-10zm4 0h-1v10h1v-10zm-2-2h-1v14h1v-14z"
            />
          </svg>
          <svg
            v-if="notification.type == 'ONETIME_AUDIO_UPLOAD'"
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            class="fill-[#6193F6] h-10"
          >
            <path d="M12 16V4l3 3 1.5-1.5L12 1 7.5 5.5 9 7l3-3v12zm-8 4h16v-2H4v2z" />
          </svg>
          <svg
            v-if="
              notification.type == 'VIDEO' || notification.type == 'EXTVIDEO' || notification.type == 'ONETIME_VIDEO_RESULT'
            "
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            class="fill-green-500 h-10"
          >
            <path
              d="M15 3c1.104 0 2 .896 2 2v4l7-4v14l-7-4v4c0 1.104-.896 2-2 2h-13c-1.104 0-2-.896-2-2v-14c0-1.104.896-2 2-2h13zm0 17c.552 0 1-.448 1-1v-14c0-.551-.448-1-1-1h-13c-.551 0-1 .449-1 1v14c0 .552.449 1 1 1h13zm2-9.848v3.696l6 3.429v-10.554l-6 3.429z"
            />
          </svg>
          <svg
            v-if="notification.type == 'YOUTUBE' || notification.type == 'ONETIME_YOUTUBE_RESULT'"
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            class="fill-red-500 h-10"
          >
            <path
              d="M10 9.333l5.333 2.662-5.333 2.672v-5.334zm14-4.333v14c0 2.761-2.238 5-5 5h-14c-2.761 0-5-2.239-5-5v-14c0-2.761 2.239-5 5-5h14c2.762 0 5 2.239 5 5zm-4 7c-.02-4.123-.323-5.7-2.923-5.877-2.403-.164-7.754-.163-10.153 0-2.598.177-2.904 1.747-2.924 5.877.02 4.123.323 5.7 2.923 5.877 2.399.163 7.75.164 10.153 0 2.598-.177 2.904-1.747 2.924-5.877z"
            />
          </svg>
          <svg
            v-if="notification.type == 'TRANSLATION'"
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            class="fill-[#6193F6] h-10"
          >
            <path
              d="M24 24h-2.784l-1.07-3h-4.875l-1.077 3h-2.697l4.941-13h2.604l4.958 13zm-4.573-5.069l-1.705-4.903-1.712 4.903h3.417zm-9.252-12.804c.126-.486.201-.852.271-1.212l-2.199-.428c-.036.185-.102.533-.22 1-.742-.109-1.532-.122-2.332-.041.019-.537.052-1.063.098-1.569h2.456v-2.083h-2.161c.106-.531.198-.849.288-1.149l-2.147-.645c-.158.526-.29 1.042-.422 1.794h-2.451v2.083h2.184c-.058.673-.093 1.371-.103 2.077-2.413.886-3.437 2.575-3.437 4.107 0 1.809 1.427 3.399 3.684 3.194 2.802-.255 4.673-2.371 5.77-4.974 1.134.654 1.608 1.753 1.181 2.771-.396.941-1.561 1.838-3.785 1.792v2.242c2.469.038 4.898-.899 5.85-3.166.93-2.214-.132-4.635-2.525-5.793zm-2.892 1.531c-.349.774-.809 1.544-1.395 2.15-.09-.646-.151-1.353-.184-2.108.533-.07 1.072-.083 1.579-.042zm-3.788.724c.062.947.169 1.818.317 2.596-1.996.365-2.076-1.603-.317-2.596zm11.236-1.745l-2.075-5.533 5.414-1.104-.976 1.868c2.999 2.418 4.116 5.645 4.532 8.132-1.736-2.913-3.826-4.478-5.885-5.321l-1.01 1.958zm-7.895 10.781l1.985 5.566-5.43 1.016 1.006-1.852c-2.96-2.465-4.021-5.654-4.397-8.148 1.689 2.94 3.749 4.483 5.794 5.36l1.042-1.942zm10.795-6.029"
            />
          </svg>
          <svg
            v-if="notification.type == 'MESSAGE'"
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            class="fill-[#6193F6] h-10"
          >
            <path
              d="M12 1c-6.338 0-12 4.226-12 10.007 0 2.05.739 4.063 2.047 5.625.055 1.83-1.023 4.456-1.993 6.368 2.602-.47 6.301-1.508 7.978-2.536 9.236 2.247 15.968-3.405 15.968-9.457 0-5.812-5.701-10.007-12-10.007zm1 15h-2v-6h2v6zm-1-7.75c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z"
            />
          </svg>
          <svg
            v-else-if="isOneTimeNotification(notification) && notification.type !== 'ONETIME_YOUTUBE_RESULT' && notification.type !== 'ONETIME_AUDIO_UPLOAD' && notification.type !== 'ONETIME_VIDEO_RESULT' && notification.type !== 'ONETIME_AUDIO_RESULT'"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            class="fill-amber-600 h-10 w-10"
          >
            <path
              d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
            />
          </svg>
        </div>
        <div class="flex flex-col pl-4 w-full">
          <p class="text-sm font-semibold text-slate-800">
            {{ getTitle(notification) }}
          </p>
          <p
            :class="{
              'text-green-500':
                notification.status != NotificationStatus.FAILED,
              'text-red-500': notification.status === NotificationStatus.FAILED,
            }"
            class="text-xs font-medium"
          >
            {{ getDescription(notification) }}
          </p>
          <p class="text-xs text-slate-500 font-normal mt-1">
            {{ formatDate(notification.createdAt) }} {{ formatTime(notification.createdAt) }}
          </p>
        </div>
      </div>
    </li>
    <div
      v-else
      class="w-full flex flex-col my-auto items-center justify-center py-4"
    >
      <p class="font-medium text-sm text-slate-600 text-center w-[85%]">
        {{
          $t(
            "youre-all-caught-up-there-are-currently-no-new-notifications-for-you-keep-an-eye-out-for-any-updates-in-the-future"
          )
        }}
      </p>
    </div>
    <div
      v-if="notificationList.length != 0"
      class="flex flex-row h-12 justify-between items-center pt-4"
    >
      <div
        @click="markAllasseen"
        class="flex flex-row space-x-2 cursor-pointer"
      >
        <svg
          clip-rule="evenodd"
          fill-rule="evenodd"
          class="h-6 w-6 fill-subDark"
        >
          <path
            d="m9.831 16.198.002-.003-1.113-.996-.004.004-2.468-2.202c-.144-.128-.322-.191-.5-.191-.417 0-.749.337-.749.75 0 .206.084.412.249.56l2.478 2.21-.767.873-4.71-4.202c-.144-.128-.322-.191-.5-.191-.416 0-.749.337-.749.75 0 .206.084.412.25.56l5.268 4.7c.143.128.321.191.499.191.206 0 .41-.084.559-.25l1.264-1.437 1.677 1.496c.143.128.321.191.499.191.206 0 .409-.084.558-.25l11.234-12.499c.129-.143.192-.322.192-.501 0-.419-.338-.75-.748-.75-.206 0-.411.084-.559.249l-10.735 11.943zm-.451-1.75 1.114.996 8.316-9.182c.128-.143.191-.322.191-.501 0-.419-.337-.75-.748-.75-.206 0-.411.084-.559.249z"
            fill-rule="nonzero"
          />
        </svg>
        <p class="text-subDark text-base font-bold">
          {{ $t("mark-all-as-seen") }}
        </p>
      </div>
      <button
        @click="navigateToNotification"
        class="bg-subDark text-white text-sm font-bold py-1 px-8 h-10 rounded"
      >
        <p>{{ $t("view-all-notifications") }}</p>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, onMounted, ref, watch } from "vue";
import {
  API_BASE_URL,
  GETNOTIFICATION,
  MARKALLSEEN,
} from "../../../utils/appConst";
import { useAuthStore } from "../../../store/auth";
import {
  NotificationModel,
  NotificationStatus,
} from "../../../utils/notificationModel";
import { useNotificationStore } from "../../../store/notification";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { toast } from "vue3-toastify";
import { languages } from "../../../utils/languageList";
import { useHead } from "@vueuse/head";

const router = useRouter();
const authStore = useAuthStore();
const { t, locale } = useI18n();
const notificationStore = useNotificationStore();
const getNotificationUrl = `${API_BASE_URL}${GETNOTIFICATION}`;
const marlAllSeenUrl = `${API_BASE_URL}${MARKALLSEEN}`;
const isLoading = ref(false);
const notificationList = computed({
  get: () => notificationStore.dropNotificationList,
  set: (value) => (notificationStore.dropNotificationList = value),
});
const isLoadedAlready = computed({
  get: () => notificationStore.isLoadedAlready,
  set: (value) => (notificationStore.isLoadedAlready = value),
});

// Legacy performance plan: fetch notifications only once (when not yet loaded). Panel open uses in-memory list only—no API call.
onBeforeMount(async () => {
  if (!isLoadedAlready.value) {
    await getNotification();
  }
  console.log(" notificationList.value ",  notificationList.value);
});

// Do not refetch when panel opens: use notificationStore.dropNotificationList from memory (legacy performance plan).

function isOneTimeNotification(notification: NotificationModel): boolean {
  const type = String(notification.type || "").toUpperCase();
  return type === "ONETIME_AUDIO_UPLOAD" || type === "ONETIME_AUDIO_RESULT" || type.includes("ONETIME");
}

function getTitle(notification: NotificationModel): string {
  if (isOneTimeNotification(notification)) {
    if (String(notification.type).toUpperCase().includes("UPLOAD")) {
      return notification.orderSourceType === "video" ? t("One-time_video_upload_title") : t("One-time_audio_upload_title");
    }
    if (notification.type === "ONETIME_YOUTUBE_RESULT") return t("One-time_youtube_result_title");
    if (notification.type === "ONETIME_VIDEO_RESULT") return t("One-time_video_result_title");
    return t("One-time_audio_result_title");
  }
  if (notification.type == "TRANSLATION") {
    return t("Your_Translation_is_Ready");
  } else {
    if (notification.status === NotificationStatus.FAILED) {
      return t("transcription-failed");
    }
    return t("Your_Transcription_is_Ready");
  }
}

function getDescription(notification: NotificationModel): string {
  if (isOneTimeNotification(notification)) {
    let base =
      notification.message
        ? notification.message
        : String(notification.type).toUpperCase().includes("UPLOAD")
          ? (notification.orderSourceType === "video" ? t("One-time_video_upload_description") : t("One-time_audio_upload_description"))
          : notification.type === "ONETIME_YOUTUBE_RESULT"
            ? t("One-time_youtube_result_description")
            : notification.type === "ONETIME_VIDEO_RESULT"
              ? t("One-time_video_result_description")
              : t("One-time_audio_result_description");
    const hasTarget = notification.targetLang != null && String(notification.targetLang).trim() !== "";
    const isUpload = String(notification.type).toUpperCase().includes("UPLOAD");
    // Upload: no language part – just the base message for a cleaner feel
    if (isUpload) {
      return base;
    }
    const hasTitle = notification.fileName != null && String(notification.fileName).trim() !== "";
    const hasSource = notification.originalLang != null && String(notification.originalLang).trim() !== "" && String(notification.originalLang).trim().toLowerCase() !== "auto";
    if (hasTitle || hasSource || hasTarget) {
      let legacy = hasTitle ? notification.fileName!.trim() + " " : "";
      if (hasSource && hasTarget) {
        legacy += (hasTitle ? "" : t("Your") + " ") + t("transcription") + " " + t("from") + " " + getLanguageName(notification.originalLang!.trim()) + " " + t("to") + " " + getLanguageName(String(notification.targetLang!).trim()) + " " + t("is-now-available");
      } else if (hasSource) {
        legacy += (hasTitle ? "" : t("Your") + " ") + t("transcription") + " " + t("from") + " " + getLanguageName(notification.originalLang!.trim()) + " " + t("is-now-available");
        if (hasTarget) legacy += " " + t("to") + " " + getLanguageName(String(notification.targetLang!).trim());
      } else {
        legacy += base;
        if (hasTarget) legacy += " " + t("to") + " " + getLanguageName(String(notification.targetLang!).trim());
      }
      return legacy.trim();
    }
    return base;
  }
  if (notification.status === NotificationStatus.FAILED) {
    return t(
      "there-was-an-issue-processing-your-transcription-please-try-again-later"
    );
  }
  const hasSource = notification.originalLang != null && String(notification.originalLang).trim() !== "";
  if (!hasSource) {
    return notification.type === "TRANSLATION"
      ? t("Your") + " " + t("translation") + " " + t("is-now-available")
      : t("Your") + " " + t("transcription") + " " + t("is-now-available");
  }
  let message = notification.fileName || t("Your");
  message +=
    notification.type === "TRANSLATION"
      ? " " + t("translation")
      : " " + t("transcription");
  message +=
    " " + t("from") + " " + getLanguageName(notification.originalLang!);
  if (notification.type == "TRANSLATION") {
    return (message +=
      " " +
      t("to") +
      " " +
      notification.targetLang +
      " " +
      t("is-now-available"));
  } else {
    return (message += " " + t("is-now-available"));
  }
}

const formatDate = (date: Date) => {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
    return "";
  }
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  };
  return date.toLocaleDateString(locale.value === "ar" ? "ar-SA" : "en-US", options);
};

const formatTime = (date: Date) => {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
    return "";
  }
  const timeOptions: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };
  return date.toLocaleTimeString(locale.value === "ar" ? "ar-SA" : "en-US", timeOptions);
};

const getNotification = async () => {
  try {
    isLoading.value = true;
    const getData = await fetch(`${getNotificationUrl}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: JSON.stringify({ page: 1 }),
    });

    if (!getData.ok) {
      throw new Error(`HTTP error! Status: ${getData.status}`);
    }

    const { notifications } = await getData.json();

    notificationList.value = notifications.map((notification: any) => ({
      id: notification.notificationId,
      message: notification.message || null,
      type: notification.type,
      seen: notification.seen,
      createdAt: new Date(notification.createdDate),
      originalLang: notification.originalLang,
      targetLang: notification.targetLang,
      requestId: notification.requestId || null,
      relatedRequestId: notification.relatedRequestId || null,
      videoLink: notification.youtubeVideoId || notification.videoLink || null,
      audioLink: notification.audioLink || null,
      fileName: notification.videoTitle || notification.audioTitle || null,
      status:
        (notification.status as NotificationStatus) ||
        NotificationStatus.SUCCESS,
      uploadAlreadyUsed: notification.uploadAlreadyUsed === true,
      consumed: notification.consumed === true,
      orderSourceType: notification.orderSourceType ?? null,
    }));    
    notificationList.value.splice(6);
    console.log("[Notifications] panel opened, all notifications:", notificationList.value);
    isLoading.value = false;
    isLoadedAlready.value = true;
  } catch (error) {
    console.log("getNotification: ", error);
    isLoading.value = false;
  }
};

const markAsSeen = async (notifyId: string) => {
  try {
    const getData = await fetch(`${getNotificationUrl}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: JSON.stringify({ notificationId: notifyId }),
    });
    if (!getData.ok) {
      throw new Error(`HTTP error! Status: ${getData.status}`);
    }
    const result = await getData.json();
    if (result.message) {
      const notificationIndex = notificationList.value.findIndex(
        (notification) => notification.id === notifyId
      );
      if (notificationIndex !== -1) {
        notificationList.value[notificationIndex].seen = true;
      }
      authStore.decrementSeen();
    }
  } catch (error) {
    console.log("getNotification: ", error);
  }
};

const handleClickEvent = async (notification: NotificationModel) => {
  try {
    if (notification.type === "ONETIME_AUDIO_UPLOAD" && (notification.consumed || notification.uploadAlreadyUsed)) {
      return;
    }
    if (!notification.seen) {
      await markAsSeen(notification.id);
    }
    if (notification.status === NotificationStatus.FAILED) {
      return;
    }
    if (notification.requestId) {
      notificationStore.setRequest(notification.requestId);
      if (notification.type === "AUDIO") {
        router.push({
          name: "AudioTranscriptor",
          query: {
            req: notification.requestId,
            //tr: notification.relatedRequestId,
          },
        });
      } else if (notification.type === "EXTAUDIO") {
        router.push({
          name: "AudioTranscriptor",
          query: {
            req: notification.requestId,
            //tr: notification.relatedRequestId,
            link: notification.audioLink,
          },
        });
      } else if (notification.type === "YOUTUBE") {
        router.push({
          name: "Youtube",
          query: {
            req: notification.requestId,
            //tr: notification.relatedRequestId,
          },
        });
      } else if (notification.type === "VIDEO") {
        router.push({
          name: "VideoEditor",
          query: {
            req: notification.requestId,
            //tr: notification.relatedRequestId,
          },
        });
      } else if (notification.type === "EXTVIDEO") {
        router.push({
          name: "VideoEditor",
          query: {
            req: notification.requestId,
            //tr: notification.relatedRequestId,
            link: notification.videoLink,
          },
        });
      } else if (notification.type === "TRANSLATION") {
        router.push({
          name: "AudioTranscriptor",
          query: {
            text: notification.requestId,
          },
        });
      } else if (notification.type === "ONETIME_AUDIO_UPLOAD") {
        const sourceType = notification.orderSourceType ?? "audio";
        if (sourceType === "youtube") {
          router.push({
            name: "Youtube",
            query: {
              onetime: "success",
              orderId: notification.requestId,
              type: "youtube",
            },
          });
        } else if (sourceType === "video") {
          router.push({
            name: "VideoEditor",
            query: {
              onetime: "success",
              orderId: notification.requestId,
              type: "video",
            },
          });
        } else {
          router.push({
            name: "AudioTranscriptor",
            query: {
              onetime_order: notification.requestId,
              type: "onetime_upload",
            },
          });
        }
      } else if (
        notification.type === "ONETIME_YOUTUBE_RESULT"
      ) {
        router.push({
          name: "Youtube",
          query: {
            onetime_order: notification.requestId,
            type: "onetime_result",
          },
        });
      } else if (notification.type === "ONETIME_VIDEO_RESULT") {
        router.push({
          name: "VideoEditor",
          query: {
            onetime_order: notification.requestId,
            type: "onetime_result",
          },
        });
      } else if (notification.type === "ONETIME_AUDIO_RESULT") {
        router.push({
          name: "AudioTranscriptor",
          query: {
            onetime_order: notification.requestId,
            type: "onetime_result",
          },
        });
      }
    }
  } catch (error) {
    console.log(`handleClickEvent : ${error}`);
  }
};

const navigateToNotification = () => {
  router.push({
    name: "Notifications",
  });
};

const markAllasseen = async () => {
  try {
    if (isLoading.value) {
      return;
    }
    isLoading.value = true;

    if (authStore.unseenCount === 0) {
      isLoading.value = false;
      return;
    }

    const getData = await fetch(marlAllSeenUrl, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
    });

    if (!getData.ok) {
      throw new Error(`HTTP error! Status: ${getData.status}`);
    }

    const result = await getData.json();

    if (result.message) {
      await authStore.getUnseenCount();
    }

    isLoading.value = false;
  } catch (error) {
    console.log("getNotification: ", error);
    isLoading.value = false;
    toast(t('were-fixing-a-technical-issue-so-please-try'), {
      autoClose: 2500,
      type: "error",
      theme: "light",
    });
  }
};

const closeNotificationTab = () => {
  notificationStore.showNotificationPanel = false;
};

function getLanguageName(langCode: string): string {
  return languages.find((e) => e.langCode === langCode)?.langName || langCode;
}

// Title is set by the route/page component, not by this reusable component
</script>
